import React, { useState } from 'react';
import DokanIcons from '../icon/DokanIcons';
/**
 * @param  {} {cardTitle
 * @param  {} children
 * @param  {} disableMargin}
 */
const DokanCollapsableCard = ({ cardTitle, children, disableMargin, hasIcon }) => {
    const [isCollapsed, setIsCollapsed] = useState(true);

    const handleCollapsableButton = () => {
        setIsCollapsed(!isCollapsed);
    };
    return (
        <div
            className={`px-25px py-35px rounded-md border border-primary bg-white  ${
                disableMargin ? 'mt-0px' : 'mt-20px'
            }`}
        >
            <div
                className={`flex justify-between focus:outline-none ${
                    isCollapsed ? 'pb-30px border-b border-primary' : ''
                }`}
                onClick={() => handleCollapsableButton()}
                role="button"
                tabIndex="0"
            >
                {cardTitle && (
                    <div className="flex justify-start items-center">
                        {hasIcon && <img src={hasIcon} alt={cardTitle} className="mr-10px" />}
                        <h3 className="text-primary text-md font-bold">{cardTitle}</h3>
                    </div>
                )}

                <button className="text-primary text-sm font-bold focus:outline-none" type="button">
                    {isCollapsed ? (
                        <DokanIcons icon="#arrowUpst" size={3} />
                    ) : (
                        <DokanIcons icon="#arrowDownst" size={3} />
                    )}
                </button>
            </div>

            {isCollapsed && <div className="mt-20px">{children}</div>}
        </div>
    );
};

export default DokanCollapsableCard;
